import { render, staticRenderFns } from "./RideitInvitationTable.vue?vue&type=template&id=716672ea"
import script from "./RideitInvitationTable.vue?vue&type=script&lang=ts"
export * from "./RideitInvitationTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports